// Theme: urban-concrete
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'urban-concrete',
  name: 'URBAN CONCRETE',
  tagline: 'URBAN CONCRETE',
  description: 'Cinza urbano de concreto exposto com acabamento limpo.',
  category: 'urban-expression',
  tier: 'common',
  basePrice: 1575,
  swatches: ['#2E3033', '#3A3D41', '#A1A7AE', '#E7EAEE'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.20)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 24%, transparent)'
    },
    shellClasses: 'font-mono theme-urban-concrete'
  },
  colorVars: {
    '--accent': '#A1A7AE',
    '--accent-foreground': '#2E3033',
    '--background': '#2E3033',
    '--border': '#5C6168',
    '--card': '#3A3D41',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 30%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E7EAEE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 4%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2E3033',
    '--foreground': '#E7EAEE',
    '--hold-fill': '#A1A7AE',
    '--input': '#5C6168',
    '--modal-bg': '#2E3033',
    '--modal-border': '#5C6168',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.20)',
    '--muted': '#5C6168',
    '--muted-foreground': '#E1E4E8',
    '--nav-active': '#A1A7AE',
    '--nav-bg': '#3A3D41',
    '--popover': '#3A3D41',
    '--popover-foreground': '#E7EAEE',
    '--primary': '#A1A7AE',
    '--primary-foreground': '#2E3033',
    '--ring': '#A1A7AE',
    '--secondary': '#5C6168',
    '--secondary-foreground': '#E7EAEE',
    '--streak': '#A1A7AE',
    '--success': '#22c55e',
    '--success-foreground': '#2E3033',
    '--xp': '#A1A7AE',
    '--xp-bg': '#3A3D41'
  },
  resolvedVars: {
    '--accent': '#A1A7AE',
    '--accent-foreground': '#2E3033',
    '--accent-foreground-hsl': '216 5% 19%',
    '--accent-foreground-oklch': 'from #2E3033 l c h',
    '--accent-hsl': '212 7% 66%',
    '--accent-oklch': 'from #A1A7AE l c h',
    '--background': '#2E3033',
    '--background-hsl': '216 5% 19%',
    '--background-oklch': 'from #2E3033 l c h',
    '--border': '#5C6168',
    '--border-hsl': '215 6% 38%',
    '--border-oklch': 'from #5C6168 l c h',
    '--border-w': '1px',
    '--card': '#3A3D41',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 30%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E7EAEE',
    '--card-foreground-hsl': '214 17% 92%',
    '--card-foreground-oklch': 'from #E7EAEE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 4%, transparent)',
    '--card-hsl': '214 6% 24%',
    '--card-oklch': 'from #3A3D41 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#2E3033',
    '--destructive-foreground-hsl': '216 5% 19%',
    '--destructive-foreground-oklch': 'from #2E3033 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E7EAEE',
    '--foreground-hsl': '214 17% 92%',
    '--foreground-oklch': 'from #E7EAEE l c h',
    '--hold-fill': '#A1A7AE',
    '--hold-fill-hsl': '212 7% 66%',
    '--hold-fill-oklch': 'from #A1A7AE l c h',
    '--input': '#5C6168',
    '--input-hsl': '215 6% 38%',
    '--input-oklch': 'from #5C6168 l c h',
    '--modal-bg': '#2E3033',
    '--modal-bg-hsl': '216 5% 19%',
    '--modal-bg-oklch': 'from #2E3033 l c h',
    '--modal-border': '#5C6168',
    '--modal-border-hsl': '215 6% 38%',
    '--modal-border-oklch': 'from #5C6168 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.20)',
    '--muted': '#5C6168',
    '--muted-foreground': '#E1E4E8',
    '--muted-foreground-hsl': '214 13% 90%',
    '--muted-foreground-oklch': 'from #E1E4E8 l c h',
    '--muted-hsl': '215 6% 38%',
    '--muted-oklch': 'from #5C6168 l c h',
    '--nav-active': '#A1A7AE',
    '--nav-active-hsl': '212 7% 66%',
    '--nav-active-oklch': 'from #A1A7AE l c h',
    '--nav-bg': '#3A3D41',
    '--nav-bg-hsl': '214 6% 24%',
    '--nav-bg-oklch': 'from #3A3D41 l c h',
    '--popover': '#3A3D41',
    '--popover-foreground': '#E7EAEE',
    '--popover-foreground-hsl': '214 17% 92%',
    '--popover-foreground-oklch': 'from #E7EAEE l c h',
    '--popover-hsl': '214 6% 24%',
    '--popover-oklch': 'from #3A3D41 l c h',
    '--primary': '#A1A7AE',
    '--primary-foreground': '#2E3033',
    '--primary-foreground-hsl': '216 5% 19%',
    '--primary-foreground-oklch': 'from #2E3033 l c h',
    '--primary-hsl': '212 7% 66%',
    '--primary-oklch': 'from #A1A7AE l c h',
    '--radius': '10px',
    '--ring': '#A1A7AE',
    '--ring-hsl': '212 7% 66%',
    '--ring-oklch': 'from #A1A7AE l c h',
    '--secondary': '#5C6168',
    '--secondary-foreground': '#E7EAEE',
    '--secondary-foreground-hsl': '214 17% 92%',
    '--secondary-foreground-oklch': 'from #E7EAEE l c h',
    '--secondary-hsl': '215 6% 38%',
    '--secondary-oklch': 'from #5C6168 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.20)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 24%, transparent)',
    '--streak': '#A1A7AE',
    '--streak-hsl': '212 7% 66%',
    '--streak-oklch': 'from #A1A7AE l c h',
    '--success': '#22c55e',
    '--success-foreground': '#2E3033',
    '--success-foreground-hsl': '216 5% 19%',
    '--success-foreground-oklch': 'from #2E3033 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(212 7% 66% / 0.15)',
    '--xp': '#A1A7AE',
    '--xp-bg': '#3A3D41',
    '--xp-bg-hsl': '214 6% 24%',
    '--xp-bg-oklch': 'from #3A3D41 l c h',
    '--xp-hsl': '212 7% 66%',
    '--xp-oklch': 'from #A1A7AE l c h'
  }
}
